import {
	CookieConsent,
	ConsentMode,
	DataAttributes,
} from '@tulastudio/cookie-consent';
import { getString } from './strings';

document.addEventListener('DOMContentLoaded', () => {
	const cc = new CookieConsent({
		heading: getString('cookieHeading', 'Cookie-inställningar'),
		message: getString('cookieMessage', ''),
		categories: [
			{
				id: 'necessary',
				title: getString('cookieCategories.necessaryTitle', 'Nödvändiga'),
				description: getString(
					'cookieCategories.necessaryDescription',
					'Cookies som är nödvändiga för webbplatsens funktionalitet.',
				),
			},
			{
				id: 'statistics',
				title: getString('cookieCategories.statisticsTitle', 'Statistik'),
				description: getString(
					'cookieCategories.statisticsDescription',
					'Cookies som används för att mäta hur webbplatsen används.',
				),
			},
			{
				id: 'marketing',
				title: getString('cookieCategories.marketingTitle', 'Marknadsföring'),
				description: getString(
					'cookieCategories.marketingDescription',
					'Cookies som används i marknadsföringssyfte.',
				),
			},
		],
		strings: {
			accept: getString('cookieActions.accept', 'Acceptera alla'),
			configure: getString('cookieActions.configure', 'Inställningar'),
			deny: getString('cookieActions.deny', 'Endast nödvändiga'),
			acceptSelected: getString(
				'cookieActions.acceptSelected',
				'Acceptera valda',
			),
		},
		extensions: [
			new ConsentMode({
				categories: {
					ad_user_data: 'marketing',
					ad_personalization: 'marketing',
					ad_storage: 'marketing',
					analytics_storage: 'statistics',
				},
			}),
			new DataAttributes(),
		],
	});
});
